import { clsx } from 'clsx';
import { type FC, type ReactNode } from 'react';

import { useApplicationContext } from 'shared/utils/applicationContext';

import styles from './styles.css';

interface ILayoutProps {
  stretch?: boolean;
  children?: ReactNode;
}

export const Layout: FC<ILayoutProps> = ({ children, stretch }) => {
  const { config } = useApplicationContext();

  const designV2EnabledBlocks = config.get<string[]>('Martech.PikLanding.DesignV2.EnabledBlocks') ?? [];
  const isDesignV2Enabled = designV2EnabledBlocks.length > 0;

  return (
    <div
      className={clsx(styles['container'], {
        [styles['stretch']]: stretch,
        [styles['v2-design']]: isDesignV2Enabled,
      })}
    >
      {children}
    </div>
  );
};
